import {
  type MultiViewDispatchCustomEvent,
  type MultiViewDispatchCustomEventParams,
  type MultiViewEvent,
} from '../../types';

/**
 * This function dispatches a custom event with a specific action and detail to the window object.
 *
 * @since ??
 *
 * @param {MultiViewDispatchCustomEventParams} detail The custom event detail.
 */
export const dispatchCustomEvent: MultiViewDispatchCustomEvent = <TUpdatedData>(
  detail: MultiViewDispatchCustomEventParams<TUpdatedData>,
): void => {
  window.dispatchEvent(
    new CustomEvent<MultiViewEvent<TUpdatedData>>(`divi:multiView:${detail.item.action}`, {
      detail,
    }),
  );
};
